import React from "react";

class Page7 extends React.Component {
  state = {
    visible: true,
  };
  checkPageVisibility(pageNum) {
    if (pageNum == 7) {
      this.setState({
        visible: true,
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  }
  render() {
    return (
      <div>
        {this.state.visible ? (
          <div>
            <nav className="navbar fixed-top navbar-expand-sm bg-light page-title">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <h3 className="py-0 d-md-block">Learning Points</h3>
                </li>
                <li className="nav-item"></li>
              </ul>
            </nav>

            <div className="container-fluid h-100 vertical-center ">
              <div className="row h-100 justify-content-center">
                <div className="col-lg-8 col-md-12 col-sm-12 col-xs-12">
                  <div className="card mb-4 box-shadow" id="pageContent">
                    <div className="card-body d-flex flex-column text-dark">
                      <span id="moduleContentText_2">
                        <p>
                          <ol>
                            <li>
                              Changing your mind about your career direction is
                              totally normal, it shows you are self-aware and
                              have insights around what is right for you.
                            </li>
                            <br />
                            <li>
                              All experience is positive, you’ve gained skills
                              that will be transferable to other roles and
                              crucially employers value diverse experiences.
                            </li>
                            <br />
                            <li>
                              Finally, remember work that uses your strengths
                              and aligns with your values will provide a sense
                              of achievement and is more likely to be enjoyable
                              and fulfilling.
                            </li>
                          </ol>
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Page7;
